export const contractTemplateRouter = [
  {
    path: "/signatures/contract-template/list",
    name: "signatures-contract-template",
    meta: { title: "合同模板" },
    component: () => import("@/views/signatures/contract-template/list/index.vue"),
  },
  {
    path: "/signatures/contract-template/share-pdf",
    name: "signatures-contract-template-share",
    meta: { title: "合同预览" },
    component: () => import("@/views/signatures/contract-template/share-pdf/share-pdf.vue"),
  },
];
